<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <el-select
            v-model="formInline.approveState"
            placeholder="是否核准"
            style="width: 135px"
          >
            <el-option label="是否核准" value=""></el-option>
            <el-option label="待核准" value="1"></el-option>
            <el-option label="已核准" value="2"></el-option>
            <el-option label="进行中" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="month" label="月份" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="shipName" label="船名" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="peopleNum"
            label="上船人数"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="mealFeeTotal"
            label="总金额（人民币）"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope" v-if="status != '0'">{{
            scope.row.name
          }}</template> -->
          </el-table-column>
          <el-table-column
            prop="laborApproveTime"
            label="核准日期"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="approveState"
            label="状态"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.approveState == '1' ||
                  scope.row.approveState == '3' ||
                  scope.row.approveState == '4'
                    ? 'red'
                    : scope.row.approveState == '2'
                    ? 'blue'
                    : 'red'
                "
              >
                <!-- {{
                scope.row.approveState == "1"
                  ? "待核准"
                  : scope.row.approveState == "4"
                  ? "未上报"
                  : scope.row.approveState == "2"
                  ? "已核准"
                  : scope.row.approveState == "3"
                  ? "进行中"
                  : scope.row.approveState == "5"
                  ? "待确认"
                  : ""
              }} -->
                {{ scope.row.approveStateName }}
              </span>
              <!-- <span v-else class="red">未下发</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope)"
              >
                查看
              </el-button>
              <!-- <el-button type="text" size="small" class="other-watch">
                下载
              </el-button> -->
              <el-button
                v-if="scope.row.approveState == 5"
                type="text"
                size="small"
                class="other-green"
                @click="passInvite(scope)"
              >
                确认
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSpecialShipGuestMeal, crewAudit } from "@/apis/index";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 10,
      companyVisible: false,
      jobParams: {},
      remendLoading: false,
      diaList: {},
      rules: {
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCrewInfoList();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    comDetail(item) {
      // console.log(item);
      this.$router.push({
        name: "crewFoodDetail",
        params: {
          id: item.row.id,
          type: "1",
        },
      });
    },
    passInvite(item) {
      // console.log(item);
      this.$router.push({
        name: "crewFoodDetail",
        params: {
          id: item.row.id,
          type: "2",
        },
      });
    },
    async getCrewInfoList() {
      let res = await getSpecialShipGuestMeal({
        ...this.formInline,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
    },

    delInvite(scope) {
      this.$confirm("确定要淘汰吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope.row);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList(row) {
      await crewAudit({
        agentAuditState: "3",
        userId: row.userId,
        agentCyAuditId: row.agentCyAuditId,
        userOrigin: "2",
      });
      // console.log(res);
      this.getCrewInfoList();
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    async addCrewList() {
      let res = await crewAudit({
        userState: this.jobParams.userState,
        crewType: this.jobParams.crewType,
        agentAuditState: "2",
        userId: this.diaList.userId,
        agentCyAuditId: this.diaList.agentCyAuditId,
        userOrigin: "2",
      });
      if (res.code == 1) {
        this.$message({
          message: "成功",
          type: "success",
        });
        this.remendLoading = false;
        this.companyVisible = false;
        this.getCrewInfoList();
        // this.$router.push({ name: "邀请船员" });
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.remendLoading = false;
        this.companyVisible = false;
      }
      // console.log(res);
    },
  },
};
</script>
